
import { getMaterialList } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  }
})
export default class extends Vue {
  materialList: any[] = []

  currentIndex: number = -1

  // 材质
  materialName: string = ''

  // 材质id
  materialId: string = ''

  // 分类id
  classifyId: string = ''

  created() {
    this.InsteadList();
  }

  beforeRouteLeave(to: any, from: any, next: Function) {
    if (to.name === 'consumables') {
      (this as any).$vnode.parent.componentInstance.cache = {};
      (this as any).$vnode.parent.componentInstance.keys = [];
    }
    next(true);
  }

  goBack() {
    this.$router.push('/user');
  }

  // 材质详情
  goDetails(id: number) {
    this.$router.push(`/consumables-details?id=${id}&type=1`);
  }

  next() {
    if (this.materialId === '') {
      this.$message.error('请选择材质！');
    } else {
      this.$router.push(
        `/erial-product?materialName=${this.materialName}&materialId=${this.materialId}`
      );
    }
  }

  selectMaterial(index: number, id: string, name: string, classifyId: string) {
    this.currentIndex = index;
    this.materialId = id;
    this.materialName = name;
    this.classifyId = classifyId;
  }

  async InsteadList() {
    const res: any = await getMaterialList({
      pageNo: 1,
      pageSize: 20,
      companyId: 1
    });
    this.materialList = res.data.data.list;
  }
}
